import { render } from "./ImportContacts.vue?vue&type=template&id=397abe40&ts=true"
import script from "./ImportContacts.vue?vue&type=script&lang=ts"
export * from "./ImportContacts.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/aleksandrvasilevic/Documents/Dev/WEB/Pets/phone-book/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__